import React, { useState } from "react";
import Contact from "./Contact";

const EditContact = () => {
  const [records, setRecords] = useState([]);
  const [view, setView] = useState("grid"); // 'grid' or 'form'
  const [editIndex, setEditIndex] = useState(null);
  const [formData, setFormData] = useState({ address: "" });

  const handleCreate = () => {
    setFormData({ address: "" });
    setEditIndex(null);
    setView("form");
  };

  const handleEdit = (index) => {
    setFormData(records[index]);
    setEditIndex(index);
    setView("form");
  };

  const handleSubmit = (data) => {
    if (editIndex !== null) {
      console.log("Update Record", data);
      const updated = [...records];
      updated[editIndex] = data;
      setRecords(updated);
    } else {
      console.log("Post Record", data);
      setRecords([...records, data]);
    }
    setView("grid");
  };

  const handleDelete = (index) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this address?"
    );
    if (confirmDelete) {
      const updated = records.filter((_, i) => i !== index);
      setRecords(updated);
    }
  };

  return (
    <div className="container mt-4">
      <section className="content container-fluid mt-4">
        <div className="row">
          <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
            <div className="box box-primary">
              <div className="box-header with-border d-flex justify-content-between align-items-center">
                {view === "grid" ? (
                  <>
                    <h3>Address Grid</h3>
                    <button className="btn btn-primary" onClick={handleCreate}>
                      Create
                    </button>

                    <table className="table table-bordered">
                      <thead className="thead-dark">
                        <tr>
                          <th>#</th>
                          <th>Address</th>
                          <th style={{ width: "180px" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {records.length === 0 ? (
                          <tr>
                            <td colSpan="3" className="text-center text-muted">
                              No records found.
                            </td>
                          </tr>
                        ) : (
                          records.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.address}</td>
                              <td>
                                <button
                                  className="btn btn-sm btn-warning mr-2"
                                  onClick={() => handleEdit(index)}
                                >
                                  Edit
                                </button>
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() => handleDelete(index)}
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </>
                ) : (
                  <Contact
                    data={formData}
                    onSubmit={handleSubmit}
                    onCancel={() => setView("grid")}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditContact;
